import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CountersContext = createContext({ counters: null, refresh: () => {} });

export function CountersProvider({ children }) {
    const [counters, setCounters] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const [t, th, sc, dc, cl, sp] = await Promise.all([
                api.get("/internal/tickets/counters"),
                api.get("/internal/threads/counters"),
                api.get("/internal/scadenze/counters"),
                api.get("/internal/documenti/counters"),
                api.get("/internal/checklist/counters"),
                api.get("/internal/spese/counters"),
            ]);
            setCounters({ ...t.data, ...th.data, scadenze: sc.data, documenti: dc.data, checklist: cl.data, spese: sp.data });
        } catch {
            /* silent — keep last value */
        }
    }, []);

    useEffect(() => {
        refresh();
        const id = setInterval(refresh, 60000);
        return () => clearInterval(id);
    }, [refresh]);

    return (
        <CountersContext.Provider value={{ counters, refresh }}>
            {children}
        </CountersContext.Provider>
    );
}

export function useCounters() {
    return useContext(CountersContext);
}
